export const APP = "drugs";
export const CRED = "gpF3fzhq8:63ea1bf8-6043-4252-8da2-b67eb2009392";
export const URL = "https://gpF3fzhq8:63ea1bf8-6043-4252-8da2-b67eb2009392@mylogy-knnhoxr-es.searchbase.io";
export const TYPE = "_doc";
